import {ModalStateType} from 'module/Modal/reducer/ModalReducer';
import {Selector} from 'react-redux';
import {ModalKey} from 'module/Modal/type/ModalKey';
import {ModalState} from 'module/Modal/reducer/ModalType';

const s: { [k in ModalKey]?: Selector<ModalStateType, ModalState> } = {}

export function selModalStateGen(modalKey: ModalKey) {
	return (state: ModalStateType) => (state.Modal[modalKey] || {})
}